import React, { useCallback, useState } from "react";
import axiosInstance from "./base/axios";

const PutHooks = () => {
  const [isLoading, setLoading] = useState(false);
  const [data, setData] = useState();

  const callApi = useCallback((pro) => {
    setLoading(true);
    axiosInstance
      .put(pro.url, pro.body)
      .then((res) => {
        setLoading(false);
        setData(res);
      })
      .catch((err) => {
        setData(err);
        setLoading(false);
        console.log("err", err);
        // errorToast(err.response.data.message);
      });
  });

  return [isLoading, data, callApi];
};

export default PutHooks;
